import { InvoiceFormConfig } from '../types';
import {
	laborConfig,
	partsConfig,
	equipmentConfig,
	travelConfig,
	freightConfig,
	miscellaneousConfig,
} from '../../SupplierInvoiceFormNew/CostSectionConfigs';

export const createBuyerInvoiceConfig = (
	formData: any,
	workOrder: any,
	currentUser: any,
	history: any,
	onSubmit: (values: any, formInstance: any, scope: string) => Promise<any>,
	options?: {
		redirectForwardUrl?: string;
		creating?: boolean;
		updating?: boolean;
		createErrors?: string[];
		updateErrors?: string[];
		onSuccess?: (record: any) => void;
		onError?: (error: any) => void;
		onReset?: () => void;
		hasQuote?: boolean;
		parsedDataSnapshot?: any;
		disableCosts?: boolean;
		fetchTaxLineItems?: (currencyId: string) => Promise<any[]>;
		currency?: any; // Direct currency object from parent
		checkInvoiceNumber?: (value: string, supplierFacilityId?: string) => Promise<any[]>;
		// Project invoices have no work order, so there is no WO number to show. The field
		// is `required` when rendered, so it has to be switched off rather than left blank.
		hideWorkOrderNumber?: boolean;
		// Project invoices only: a short title, pre-filled from the AI extract and editable,
		// which the invoice lists show in place of the work order they don't have.
		showTitle?: boolean;
		// Also project invoices: with no work order to derive them from, the service provider
		// and the billed-to location become fields on the form. Supplying the select bindings
		// is what switches them on.
		entitySelects?: InvoiceFormConfig['entitySelects'];
	}
): InvoiceFormConfig => {
	return {
		formType: 'buyerInvoice',
		fields: {
			scope: true,
			invoiceNumber: true,
			externalWorkOrderId: !(options && options.hideWorkOrderNumber),
			supplierFacilityId: !!(options && options.entitySelects),
			locationId: !!(options && options.entitySelects),
			invoiceDate: true,
			paymentTerms: true,
			dueDate: true,
			fileAttachments: false,
			status: true, // Show pending/paid radio
			title: !!(options && options.showTitle),
		},
		entitySelects: options && options.entitySelects,
		lineItemSections: [
			{ type: 'labor', show: true, config: laborConfig },
			{ type: 'parts', show: true, config: partsConfig },
			{ type: 'equipment', show: true, config: equipmentConfig },
			{ type: 'travel', show: true, config: travelConfig },
			{ type: 'freight', show: true, config: freightConfig },
			{ type: 'misc', show: true, config: miscellaneousConfig },
		],
		tax: {
			type: 'lineItems',
			// When currency is CAD, fetch GST/PST (or other) line items and show them
			fetchTaxLineItems:
				options && options.fetchTaxLineItems ? options.fetchTaxLineItems : undefined,
		},
		currency: {
			fetchInternally: !(options && options.currency),
			source: options && options.hasQuote ? 'quote' : 'supplierFacility',
			value: options && options.currency,
		},
		onSubmit,
		validateInvoiceNumber: options && options.checkInvoiceNumber,
		formData,
		workOrder,
		currentUser,
		history,
		parsedDataSnapshot: options && options.parsedDataSnapshot,
		redirectForwardUrl: options && options.redirectForwardUrl,
		creating: options && options.creating,
		updating: options && options.updating,
		createErrors: options && options.createErrors,
		updateErrors: options && options.updateErrors,
		onSuccess: options && options.onSuccess,
		onError: options && options.onError,
		onReset: options && options.onReset,
		disableCosts: options && options.disableCosts,
	};
};
